import { FC } from 'react';
import { RadioButtonProps, Styled } from './';

export const Radio: FC<RadioButtonProps> = ({
  label,
  onChange,
  checked,
  disabled,
  testId = 'radio-button',
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  circleColor,
}) => {
  return (
    <Styled.RadioContainer
      disabled={disabled}
      onClick={() => {
        if (disabled) return false;
        onChange();
      }}
      data-testid={testId}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
    >
      <Styled.OuterCircle
        checked={checked}
        disabled={disabled}
        $circleColor={circleColor}
      >
        <Styled.InnerCircle
          checked={checked}
          disabled={disabled}
        ></Styled.InnerCircle>
      </Styled.OuterCircle>
      <Styled.Label disabled={disabled} checked={checked}>
        {label}
      </Styled.Label>
    </Styled.RadioContainer>
  );
};

export default Radio;
